import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { useScrollingTracker } from '../utils/useScrollingTracker.js';
import { useTabsContext } from './SdsTabsContext.js';
import __vue_component__ from '../SdsButtonIcon/SdsButtonIcon.vue.js';

var script = defineComponent({
    name: 'SdsTabList',
    setup: function () {
        var elementRef = ref();
        var _a = useTabsContext(), alignment = _a.alignment, background = _a.background, value = _a.value, setValue = _a.setValue;
        var _b = useScrollingTracker(elementRef, {
            direction: 'horizontal',
            delay: 0,
        }), isScrollable = _b.isScrollable, isScrolled = _b.isScrolled;
        function scrollNext() {
            var _a;
            (_a = elementRef.value) === null || _a === void 0 ? void 0 : _a.scrollBy({
                left: 100,
                behavior: 'smooth',
            });
        }
        function scrollPrevious() {
            var _a;
            (_a = elementRef.value) === null || _a === void 0 ? void 0 : _a.scrollBy({
                left: -100,
                behavior: 'smooth',
            });
        }
        onMounted(function () {
            var _a, _b, _c;
            if (value.value == null) {
                setValue((_c = (_b = (_a = elementRef.value) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.getAttribute('data-value')) !== null && _c !== void 0 ? _c : '');
            }
        });
        return {
            elementRef: elementRef,
            alignment: alignment,
            background: background,
            isLeftOverlayShown: isScrolled,
            isRightOverlayShown: isScrollable,
            scrollNext: scrollNext,
            scrollPrevious: scrollPrevious,
        };
    },
    components: {
        SdsButtonIcon: __vue_component__,
    },
});

export default script;
